import ScriptModal from './ScriptModal';

export default {
  ScriptModal,
};
